var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"border-radius-welcome",style:({
    'background-color': _vm.getWebchat().campaign.color,
    color: _vm.invertColor(_vm.getWebchat().campaign.color),
    zoom: ("1." + (_vm.getWebchat().client.accessibility.fontSize)),
  })},[(_vm.getWebchat().isLowRes)?_c('v-btn',{staticClass:"right-arrow-back",attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.minimizeWindow.apply(null, arguments)}}},[_c('v-icon',{staticStyle:{"font-size":"28px !important"},style:({
        color: _vm.invertColor(_vm.getWebchat().campaign.color),
      })},[_vm._v("mdi-chevron-left")])],1):_vm._e(),_c('div',{staticClass:"header-content"},[_c('div',{staticClass:"vtext-content",style:({
        color: _vm.invertColor(_vm.getWebchat().campaign.color),
      }),domProps:{"innerHTML":_vm._s(_vm.getText)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }